(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-cfilter]');
    if (!bar) return;
    const cards = [...document.querySelectorAll('.cpla-invcard[data-card-title]')];
    const groups = [...document.querySelectorAll('.cpla-collection__group')];
    const searchEl = bar.querySelector('[data-cfilter-search]');
    const availEl = bar.querySelector('[data-cfilter-avail]');
    const pillEls = [...bar.querySelectorAll('[data-cfilter-pill]')];
    const shownEl = bar.querySelector('[data-cfilter-shown]');
    const readyEl = bar.querySelector('[data-cfilter-ready]');
    let activeType = '';

    const apply = () => {
      const q = (searchEl?.value || '').trim().toLowerCase();
      const availOnly = !!availEl?.checked;
      let shown = 0;
      let ready = 0;
      cards.forEach((card) => {
        const matches =
          (!q || card.dataset.cardTitle.includes(q) || card.dataset.cardType.toLowerCase().includes(q)) &&
          (!availOnly || card.dataset.cardAvailable === 'true');
        if (matches) {
          card.removeAttribute('data-filtered-out');
          shown++;
          if (card.dataset.cardAvailable === 'true') ready++;
        } else {
          card.setAttribute('data-filtered-out', '');
        }
      });
      groups.forEach((g) => {
        const visible = g.querySelector('.cpla-invcard:not([data-filtered-out])');
        if (visible) g.removeAttribute('data-filtered-out');
        else g.setAttribute('data-filtered-out', '');
      });
      if (shownEl) shownEl.textContent = shown;
      if (readyEl) readyEl.textContent = ready;
    };

    searchEl?.addEventListener('input', apply);
    availEl?.addEventListener('change', apply);

    // Pills jump to that section — same behavior as the mega-menu links, so a
    // tap scrolls you straight to a clear view of that group on mobile and desktop.
    pillEls.forEach((pill) => {
      pill.addEventListener('click', () => {
        pillEls.forEach((p) => p.classList.toggle('is-active', p === pill));
        const type = pill.dataset.cfilterPill;
        let target;
        if (type) {
          const handle = type.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
          target = document.getElementById('type-' + handle);
        } else {
          target = groups[0] || bar;
        }
        if (target && target !== bar) {
          // Clear the sticky filter bar so the group's TITLE lands just below it.
          // Use the bar's sticky `top` + its height (both constant) rather than its
          // live position, so it's correct whether you tap from the top of the page
          // or already scrolled. On mobile the pills wrap to 3 rows, making the bar
          // much taller than on desktop — measuring it live keeps this exact.
          const barTop = parseFloat(getComputedStyle(bar).top) || 0;
          const stickyOffset = barTop + bar.getBoundingClientRect().height;
          const y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset - 12;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
    apply();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpla-product-fbt"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-fbt]');
    if (!root) return;
    const checks = [...root.querySelectorAll('[data-fbt-check]')];
    const btn = root.querySelector('[data-fbt-add]');
    const label = root.querySelector('[data-fbt-add-label]');
    const items = [...root.querySelectorAll('[data-fbt-item]')];
    const mainProduct = {
      handle: root.dataset.handle,
      title: root.dataset.title,
      url: root.dataset.url,
    };

    const paint = () => {
      const n = checks.filter((c) => c.checked).length + 1;
      label.textContent = n === 1 ? 'Add this item to quote' : 'Add all ' + n + ' to quote';
      btn.classList.remove('is-added');
      checks.forEach((c) => {
        const fig = items.find((f) => f.dataset.handle === c.dataset.handle);
        if (fig) fig.classList.toggle('is-off', !c.checked);
      });
    };
    checks.forEach((c) => c.addEventListener('change', paint));

    btn.addEventListener('click', () => {
      if (!window.CplaQuote) return;
      window.CplaQuote.add(mainProduct);
      checks.filter((c) => c.checked).forEach((c) => {
        window.CplaQuote.add({ handle: c.dataset.handle, title: c.dataset.title, url: c.dataset.url });
      });
      btn.classList.add('is-added');
      label.textContent = 'Added to quote ✓';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpla-reserve-form"] && !Shopify.designMode) return;
  try {
    
  // Prefill the instruments field from ?item= (product pages link here later)
  (() => {
    const item = new URLSearchParams(location.search).get('item');
    if (!item) return;
    const field = document.getElementById('cf-instruments');
    if (field && !field.value) field.value = item;
  })();

  // Route the quote through the cpla-chat backend so it emails info@ (cc lauren@)
  // AND sends the customer a confirmation. Falls back to the native Shopify form
  // if the backend isn't configured or is unreachable — so a quote is never lost.
  (() => {
    const section = document.querySelector('[data-reserve-section]');
    const endpoint = section && section.dataset.quoteEndpoint;
    const form = section && section.querySelector('form.cpla-form');
    if (!endpoint || !form) return;

    const val = (name) => {
      const el = form.querySelector('[name="' + name + '"]');
      if (el && el.type === 'radio') {
        const checked = form.querySelector('[name="' + name + '"]:checked');
        return checked ? checked.value : '';
      }
      return el ? el.value.trim() : '';
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending…'; }

      const payload = {
        first_name: val('contact[first_name]'),
        last_name: val('contact[last_name]'),
        email: val('contact[email]'),
        phone: val('contact[phone]'),
        billing_address: val('contact[Billing Address]'),
        rental_start: val('contact[Rental Start Date]'),
        rental_end: val('contact[Rental End Date]'),
        delivery: val('contact[Delivery]'),
        venue: val('contact[Venue]'),
        delivery_time: val('contact[Preferred Delivery Time]'),
        pickup_time: val('contact[Preferred Pickup Time]'),
        instruments: val('contact[Instruments]'),
        notes: val('contact[Additional Information]'),
        rider: val('contact[Technical Rider Link]'),
      };

      /* Sent as multipart so the rider file can ride along. Do NOT set a
         Content-Type header — the browser has to add the multipart boundary. */
      const fd = new FormData();
      for (const [k, v] of Object.entries(payload)) fd.append(k, v ?? '');
      const riderFile = document.getElementById('cf-rider-file')?.files?.[0];
      if (riderFile) fd.append('rider', riderFile);

      const hint = form.querySelector('[data-rider-hint]');

      try {
        const res = await fetch(endpoint, { method: 'POST', body: fd });
        // A rejected file is the customer's to fix — don't silently fall back,
        // or they'd think the rider was sent when it wasn't.
        if (res.status === 400) {
          const detail = await res.json().catch(() => ({}));
          if (detail.error === 'rider_too_large' || detail.error === 'rider_unsupported') {
            if (hint) { hint.textContent = detail.message; hint.style.color = '#c0392b'; }
            if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; }
            document.getElementById('cf-rider-file')?.focus();
            return;
          }
        }
        if (!res.ok) throw new Error('backend ' + res.status);
        try { localStorage.removeItem('cpla_quote_v1'); sessionStorage.removeItem('cpla_reserve_prefill_v1'); sessionStorage.removeItem('cpla_reserve_form_v1'); } catch (err) {}
        window.location.assign('/pages/quote-received');
      } catch (err) {
        // Backend down — let Shopify's native form handle it so nothing is lost.
        if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; }
        form.submit();
      }
    });
  })();

  // Prefill from the chat assistant. Details live in sessionStorage (set by the
  // widget), never in the URL — so no personal data is exposed in a link.
  (() => {
    let lead;
    try { lead = JSON.parse(sessionStorage.getItem('cpla_reserve_prefill_v1') || 'null'); }
    catch (e) { return; }
    if (!lead) return;

    const setVal = (id, val) => {
      const el = document.getElementById(id);
      if (el && val && !el.value) el.value = val;
    };

    if (lead.name) {
      const parts = String(lead.name).trim().split(/\s+/);
      setVal('cf-first', parts.shift() || '');
      setVal('cf-last', parts.join(' '));
    }
    setVal('cf-email', lead.email);
    setVal('cf-phone', lead.phone);
    setVal('cf-venue', lead.venue);
    if (/^\d{4}-\d{2}-\d{2}$/.test(lead.rental_start || '')) setVal('cf-start', lead.rental_start);
    if (/^\d{4}-\d{2}-\d{2}$/.test(lead.rental_end || '')) setVal('cf-end', lead.rental_end);

    // Delivery time select: match an option by text if we can, else fold into notes.
    const timeSel = document.getElementById('cf-deliver-time');
    let timeMatched = false;
    if (timeSel && lead.delivery_time) {
      const want = String(lead.delivery_time).replace(/\s+/g, '').toLowerCase();
      for (const opt of timeSel.options) {
        if (opt.text.replace(/\s+/g, '').toLowerCase() === want) { timeSel.value = opt.value; timeMatched = true; break; }
      }
    }

    // Anything that doesn't map to a field goes into the notes so nothing is lost.
    const extras = [];
    if (lead.dates && !document.getElementById('cf-start').value) extras.push('Dates: ' + lead.dates);
    if (lead.delivery_time && !timeMatched) extras.push('Preferred time: ' + lead.delivery_time);
    if (lead.needs) extras.push(lead.needs);
    if (extras.length) {
      const notes = document.getElementById('cf-notes');
      if (notes && !notes.value) notes.value = extras.join('\n');
    }

    // One-time fill — clear so a later manual visit starts clean.
    try { sessionStorage.removeItem('cpla_reserve_prefill_v1'); } catch (e) {}
  })();

  // Keep the customer's own entries (name, email, dates, venue, times…) as they
  // navigate off to browse the catalog and come back. sessionStorage, so it lives
  // for the visit and clears when the tab closes — right for personal details.
  (() => {
    const form = document.querySelector('[data-reserve-section] form.cpla-form');
    if (!form) return;
    const KEY = 'cpla_reserve_form_v1';
    const fields = () => Array.prototype.filter.call(
      form.querySelectorAll('input, select, textarea'),
      (el) => el.name && el.name !== 'contact[Instruments]' && el.type !== 'hidden' && el.type !== 'submit'
    );

    // Restore what they entered earlier this session — but never overwrite a field
    // the chat prefill above already filled.
    try {
      const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (saved) {
        fields().forEach((el) => {
          if (!(el.name in saved)) return;
          if (el.type === 'radio') { if (el.value === saved[el.name]) el.checked = true; }
          else if (!el.value) { el.value = saved[el.name]; }
        });
      }
    } catch (e) {}

    const save = () => {
      const data = {};
      fields().forEach((el) => {
        if (el.type === 'radio') { if (el.checked) data[el.name] = el.value; }
        else if (el.value) { data[el.name] = el.value; }
      });
      try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
    };
    form.addEventListener('input', save);
    form.addEventListener('change', save);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpla-sticky-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-stickybar]');
    if (!bar) return;
    bar.removeAttribute('hidden');

    // Reveal once the visitor scrolls past the hero's quote form
    const trigger = document.querySelector('.cpla-lhero') || document.querySelector('.cpla-phero');
    const onScroll = () => {
      const past = trigger ? window.scrollY > trigger.offsetHeight * 0.9 : window.scrollY > 600;
      bar.classList.toggle('is-visible', past);
      liftChat(past);
    };

    /* Lift the chat launcher above this bar so it stops covering the bar's own
       CTA. Set inline so it beats the widget's own rule regardless of load
       order, and read offsetHeight directly — the bar already carries the
       safe-area inset in its padding, so its height accounts for the notch. */
    const liftChat = (past) => {
      const chat = document.querySelector('.cpla-chat');
      if (!chat) return;
      chat.style.bottom = past ? bar.offsetHeight + 16 + 'px' : '';
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Mirror the Add-to-Quote count when the shopper has items going
    const wrap = bar.querySelector('[data-stickybar-count-wrap]');
    const countEl = bar.querySelector('[data-stickybar-count]');
    const sync = () => {
      const n = window.CplaQuote ? window.CplaQuote.count() : 0;
      if (wrap) wrap.hidden = n === 0;
      if (countEl) countEl.textContent = n;
    };
    document.addEventListener('cpla:quote', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-cpla-header]');
    if (!header) return;

    // Subtle elevation when scrolled
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Per-item dropdowns — hover with a grace period
    const wraps = [...header.querySelectorAll('[data-drop-wrap]')];
    let closeTimer = null;
    const closeAll = () => {
      wraps.forEach((w) => {
        w.classList.remove('is-open');
        w.querySelector('a').setAttribute('aria-expanded', 'false');
        w.querySelector('[data-drop]').setAttribute('aria-hidden', 'true');
      });
      header.classList.remove('is-drop-open');
    };
    const open = (wrap) => {
      clearTimeout(closeTimer);
      wraps.forEach((w) => {
        const on = w === wrap;
        w.classList.toggle('is-open', on);
        w.querySelector('a').setAttribute('aria-expanded', String(on));
        w.querySelector('[data-drop]').setAttribute('aria-hidden', String(!on));
      });
      header.classList.add('is-drop-open');
    };
    // Hover-opening stays disarmed until the pointer has genuinely LEFT the nav
    // items. Clicking a nav item navigates with the cursor still parked on it —
    // without this, the next mouseenter (which fires readily while scrolling
    // under the sticky header) would reopen the panel over the page the visitor
    // just asked for.
    let armed = false;
    document.addEventListener(
      'mousemove',
      (e) => {
        if (armed) return;
        const overNav = e.target.closest && e.target.closest('[data-drop-wrap]');
        if (!overNav) armed = true;
      },
      { passive: true }
    );

    wraps.forEach((wrap) => {
      wrap.addEventListener('mouseenter', () => {
        if (armed) open(wrap);
      });
      wrap.addEventListener('mouseleave', () => {
        armed = true;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAll, 140);
      });
      const trigger = wrap.querySelector('a');
      trigger.addEventListener('focus', () => open(wrap));
      // Clicking the top-level item navigates — get the panel out of the way
      // immediately instead of letting it cover the destination page.
      trigger.addEventListener('click', () => {
        armed = false;
        closeAll();
      });
      // Same-page anchor clicks never reload, so close the panel explicitly
      wrap.querySelectorAll('[data-drop] a').forEach((a) => {
        a.addEventListener('click', () => {
          armed = false;
          closeAll();
        });
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    // Mobile drawer
    const drawer = document.querySelector('[data-drawer]');
    const toggle = header.querySelector('[data-drawer-toggle]');
    const scrim = drawer && drawer.querySelector('[data-drawer-scrim]');
    const setDrawer = (isOpen) => {
      drawer.classList.toggle('is-open', isOpen);
      drawer.setAttribute('aria-hidden', String(!isOpen));
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('cpla-drawer-open', isOpen);
    };
    if (drawer && toggle) {
      toggle.addEventListener('click', () => setDrawer(!drawer.classList.contains('is-open')));
      if (scrim) scrim.addEventListener('click', () => setDrawer(false));
      drawer.querySelectorAll('[data-drawer-close]').forEach((btn) => {
        btn.addEventListener('click', () => setDrawer(false));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const main = document.getElementById('cpla-main-image');
    // Zoom must work on single-image products, so only thumbnail wiring depends on thumbs.
    if (!main) return;
    const thumbs = [...document.querySelectorAll('.cpla-product__thumb')];
    const counter = document.querySelector('[data-gallery-counter]');
    let index = 0;

    const show = (i) => {
      if (!thumbs.length) return;
      index = (i + thumbs.length) % thumbs.length;
      const btn = thumbs[index];
      main.src = btn.dataset.full;
      main.removeAttribute('srcset');
      thumbs.forEach((b, n) => b.classList.toggle('is-active', n === index));
      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
    };

    thumbs.forEach((btn, i) => btn.addEventListener('click', () => show(i)));
    document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    document.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));

    // --- Zoom lightbox ---
    const box = document.querySelector('[data-zoom]');
    const boxImg = box && box.querySelector('[data-zoom-img]');
    const boxCounter = box && box.querySelector('[data-zoom-counter]');
    let sources = [];
    try {
      sources = JSON.parse(document.querySelector('[data-gallery-sources]')?.textContent || '[]');
    } catch (e) {}

    const paint = () => {
      const item = sources[index] || sources[0];
      if (!item || !boxImg) return;
      boxImg.src = item.src;
      boxImg.alt = item.alt || '';
      if (boxCounter) boxCounter.textContent = sources.length > 1 ? index + 1 + ' / ' + sources.length : '';
    };
    const openZoom = () => {
      if (!box) return;
      box.removeAttribute('hidden');
      requestAnimationFrame(() => box.classList.add('is-open'));
      document.body.classList.add('cpla-zoom-open');
      paint();
    };
    const closeZoom = () => {
      if (!box) return;
      box.classList.remove('is-open');
      document.body.classList.remove('cpla-zoom-open');
      setTimeout(() => box.setAttribute('hidden', ''), 200);
    };
    const stepZoom = (delta) => {
      if (!sources.length) return;
      index = (index + delta + sources.length) % sources.length;
      if (thumbs.length) thumbs.forEach((b, n) => b.classList.toggle('is-active', n === index));
      main.src = thumbs[index] ? thumbs[index].dataset.full : main.src;
      main.removeAttribute('srcset');
      if (counter) counter.textContent = index + 1 + ' / ' + Math.max(thumbs.length, sources.length);
      paint();
    };

    main.addEventListener('click', openZoom);
    document.querySelector('[data-zoom-open]')?.addEventListener('click', (e) => {
      e.stopPropagation();
      openZoom();
    });
    document.querySelector('[data-zoom-close]')?.addEventListener('click', closeZoom);
    document.querySelector('[data-zoom-prev]')?.addEventListener('click', () => stepZoom(-1));
    document.querySelector('[data-zoom-next]')?.addEventListener('click', () => stepZoom(1));
    box?.addEventListener('click', (e) => {
      if (e.target === box) closeZoom();
    });

    document.addEventListener('keydown', (e) => {
      if (e.target instanceof Element && e.target.matches('input, textarea, select')) return;
      const zoomOpen = box && !box.hasAttribute('hidden');
      if (e.key === 'Escape' && zoomOpen) return closeZoom();
      if (e.key === 'ArrowLeft') zoomOpen ? stepZoom(-1) : show(index - 1);
      if (e.key === 'ArrowRight') zoomOpen ? stepZoom(1) : show(index + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
